import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { InformesService } from 'app/services/informes.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-bitacora',
  templateUrl: './bitacora.component.html',
  styleUrls: ['./bitacora.component.scss']
})
export class BitacoraComponent implements OnInit {
  
  //DataTable
  public dtOption;
  public tableOpt;
  @ViewChild(DataTableDirective, {static:true})
  tabla: DataTableDirective;
  public dtTrigger:Subject<void>;

  constructor(@Inject(MAT_DIALOG_DATA) private data, private _informe:InformesService) {
    this.dtTrigger = new Subject();
    this.dtTrigger.next();
    
    this.tableOpt = [];
    this.dtOption = {
      columns: [
        {
          title: 'Usuario',
          data: 'NomUsuario'
        },
        {
          title: 'Documento',
          data: 'bendoc'
        },
        {
          title: 'Beneficiario',
          data: 'bennom'
        },
        {
          title: 'ConAnt',
          data: 'conant'
        },
        {
          title: 'TNitAnt',
          data: 'titant'
        },
        {
          title: 'Titular Anterior',
          data: 'titularant'
        },
        {
          title: 'TNitNvo',
          data: 'titnvo'
        },
        {
          title: 'Nuevo Titular',
          data: 'titularnvo'
        },
        {
          title: 'Estado Anterior',
          data: 'estado_anterior'
        },
        {
          title: 'Nuevo Estado',
          data: 'estado_nuevo'
        },
        {
          title: 'Actividad Realizada',
          data: 'actividad'
        },
        {
          title: 'Fecha',
          data: 'fyhsis'
        }
      ]
    }
  }

  ngOnInit() {
    this._informe.Bitacora(this.data.beneficiario_doc).subscribe((data:any) => {
      this.tableOpt = data.resultado;
      this.dtTrigger.next();
    });
  }

}
